<script setup>
import { onMounted, watch, ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import setTooltip from "@/assets/js/tooltip.js";

import DataTables from "./components/DataTables.vue";
import PieChart from "./components/CensadoChart.vue";
import BarChart from "./components/BarChart.vue";

const store = useStore();
const route = useRoute();
const provinceId = ref("1"); // Default San José (1)

// Mapeo de provincias por ID
const provinceMap = {
  "San José": "1",
  "Alajuela": "2",
  "Cartago": "3",
  "Heredia": "4",
  "Guanacaste": "5",
  "Puntarenas": "6",
  "Limón": "7",
  "Extranjeros": "8",
};

if (window.innerWidth <= 768) { // Ajusta el navbar en dispositivos móviles
  store.commit("navbarMinimize");
}


// Actualiza el ID de la provincia
const updateProvinceId = () => {
  provinceId.value = provinceMap[route.params.province] || "1";
};

// Checkea cambios en la ruta por ID de provincia
watch(() => route.params.province, updateProvinceId, { immediate: true });

onMounted(() => {
  setTooltip(store.state.bootstrap);
});
</script>

<template>
<div class="p-3 py-md-4 p-lg-4 container-fluid">
  <div class="row">
      <div class="col-lg-7 col-md-12 mt-lg-0">
        <bar-chart :provinceId="provinceId" />
      </div>

      <div class="mt-4 col-lg-5 col-md-12 mt-lg-0">
        <pie-chart :provinceId="provinceId" />
      </div> 
    </div>

    <div class="mt-4 row">
      <div class="col-sm-12">
        <data-tables :provinceId="provinceId" :applyFilters="false" 
        />
      </div>
    </div>
  </div>
</template>

<style>
div.row {
  --bs-gutter-x: 1.5rem;
}
</style>
